import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ContextService } from '@app/core/service/context.service';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../business/user/authentication.service';

@Injectable()
export class ContextGuardService  {
  constructor(private authenticationService: AuthenticationService, private contextService: ContextService, private router: Router) {}

  canActivate() {
    return this.contextService.context$.pipe(
      map(x => {
        if (this.authenticationService.checkConnection() && (
          !x.companyCode ||
          x.companyCode.length <= 0 ||
          !x.customerCode ||
          x.customerCode.length <= 0
        )) {
          this.router.navigateByUrl('context');
        } else {
          return true;
        }
      })
    );
  }
}
